import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import './Stories.css'
import ReactLoading from 'react-loading';
import { deleteStoryDetails, emptyStoryDetails, loadStoryDetails } from '../../Redux/Actions/ActionStories';
import SinglePagenation from '../General/Pagination/SinglePagenation';
import { useParams } from 'react-router-dom';

function StoryDetails() {
    let role = localStorage.getItem('roleA');
    let dispatch = useDispatch();
    let { id } = useParams();
    const [pageNumber, setPageNumber] = useState(0);
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const storyDetails = useSelector(state => state.stories.storyDetails)
    const loadingStoryDetails = useSelector(state => state.stories.loadingStoryDetails)
    useEffect(() => {
        dispatch(loadStoryDetails(id));
        return () => {
            dispatch(emptyStoryDetails());
        }
    }, [])
    const handleDelete = (idd) => {
        dispatch(deleteStoryDetails(id, idd))
    }
    const stroiesPerPage = 12;
    const pagesVisited = pageNumber * stroiesPerPage;
    const displaystories = storyDetails.slice(
        pagesVisited,
        pagesVisited + stroiesPerPage
    );

    const pageCount = Math.ceil(storyDetails.length / stroiesPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('stories')}</h2>
                </div>
                <div className='allstoryDD' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingStoryDetails == false ? (
                            displaystories.map((dd) => {
                                return (
                                    <div className='onestoryDD' >
                                        {
                                            role !== '2' ? (
                                                <i className='fa fa-trash stroy_del' onClick={() => handleDelete(dd.id)} ></i>
                                            ) : ''
                                        }
                                        <img src={dd.image} />
                                        <video src={dd.video} controls />
                                    </div>
                                )
                            })) : <div className="div_loading_normal" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
                <SinglePagenation pageCount={pageCount} changePage={changePage} />
            </main>
        </>
    )
}

export default StoryDetails
